import { render, staticRenderFns } from "./mechanismAccount.vue?vue&type=template&id=656398de&scoped=true&"
import script from "./mechanismAccount.vue?vue&type=script&lang=js&"
export * from "./mechanismAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656398de",
  null
  
)

export default component.exports